export const API_PROJECTS_PUBLICATIONS_SECTION_FIELDS = [
    'project_first_type.publications_section.id',
    'project_first_type.publications_section.status',
    'project_first_type.publications_section.sort',
    'project_first_type.publications_section.publications',
    'project_first_type.publications_section.translations'
];
